function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.477 7.903c.946 0 1.758.97 1.892 1.923l.14.983c.282 1.987.415 2.92.415 3.755 0 .365.01 1.002.024 1.651.022 1.06.052 2.155.052 2.155h-1.013c-.69-2.982-2.361-3.806-4.216-3.806-1.854 0-2.341.476-2.341.476V7.903h5.047zM21.24 9.33v3.33h3.279s-.115-2.16-.937-2.854c-.822-.694-2.342-.476-2.342-.476z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.493 18.758c0-1.791 1.43-3.243 3.192-3.243 1.762 0 3.192 1.452 3.192 3.243 0 1.79-1.43 3.242-3.192 3.242-1.763 0-3.192-1.452-3.192-3.242zm1.254 0c0 1.087.868 1.969 1.938 1.969 1.07 0 1.938-.882 1.938-1.969 0-1.088-.868-1.969-1.938-1.969-1.07 0-1.938.881-1.938 1.969zM5.02 15.515c-1.763 0-3.192 1.452-3.192 3.243 0 1.79 1.43 3.242 3.192 3.242 1.763 0 3.192-1.452 3.192-3.242 0-1.791-1.429-3.243-3.192-3.243zm0 5.212c-1.07 0-1.939-.882-1.939-1.969 0-1.088.868-1.969 1.939-1.969 1.07 0 1.938.881 1.938 1.969 0 1.087-.868 1.969-1.938 1.969z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.81 6h-8.06c-.82 0-1.482.636-1.482 1.424v.116H1l.003 6.42c0 .898.708 1.621 1.573 1.621h.102v.024c.662-.514 1.448-1.041 2.342-1.041 1.703 0 3.956 1.04 3.956 3.806h7.48c0-.877.273-1.903 1.186-2.765V7.517h4.168a.746.746 0 0 0 .736-.758A.75.75 0 0 0 21.81 6z"
});

var SvgPickupTruck = function SvgPickupTruck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPickupTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pickup-truck.9a9e1b26.svg";
export { ForwardRef as ReactComponent };